var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    stroke: "currentColor",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 632.99 460.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,460.43c-145.23,0-271.88-89.1-315.12-221.68-1.83-5.56-1.83-11.52,0-17.07C44.64,89.1,171.29,0,316.49,0s271.85,89.1,315.13,221.68c1.83,5.56,1.83,11.51,0,17.07-43.25,132.58-169.9,221.68-315.13,221.68ZM56.56,230.22c38.44,105.2,141.74,175.24,259.93,175.24s221.49-70.04,259.94-175.24c-38.47-105.2-141.74-175.24-259.94-175.24S95.03,125.02,56.56,230.22Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.49,379.12c-82.12,0-148.93-66.82-148.93-148.93,0-15.19,12.29-27.49,27.49-27.49s27.49,12.3,27.49,27.49c0,51.81,42.15,93.96,93.95,93.96,15.2,0,27.49,12.3,27.49,27.49s-12.29,27.49-27.49,27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.89,257.68c-15.2,0-27.49-12.29-27.49-27.49,0-51.78-42.12-93.9-93.9-93.9-15.19,0-27.49-12.29-27.49-27.49s12.3-27.49,27.49-27.49c82.09,0,148.88,66.79,148.88,148.88,0,15.2-12.3,27.49-27.49,27.49Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.46,453.7c-7.03,0-14.07-2.69-19.43-8.05L101.04,53.64c-10.74-10.74-10.74-28.13,0-38.87,10.74-10.74,28.13-10.74,38.87,0l391.98,392.01c10.74,10.74,10.74,28.13,0,38.87-5.37,5.37-12.4,8.05-19.44,8.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideBlackIcon);
export default __webpack_public_path__ + "static/media/Hide_BlackIcon.16f490f912dd8bfb33a715faab98d998.svg";
export { ForwardRef as ReactComponent };